import { $host } from "./index";

export type Chat = {
  id: number;
  name: string;
  created: Date;
};

export type ChatMemebr = {
  id: number;
  sysName: string;
  chatId: number;
  userId: number;
  lastRead: Date;
};

export type ChatMessage = {
  id: number;
  chatMemberId: number;
  sysName?: string;
  date: Date;
  text: string;
};

export class ChatService {
  static async getChatInfo(chatId: number): Promise<Chat> {
    const result = await $host.get("/chat/info/" + chatId);
    return result.data;
  }

  static async getChatMembers(chatId: number): Promise<ChatMemebr[]> {
    const result = await $host.get("/chat/members/" + chatId);
    return result.data;
  }

  static async addChatMembers(
    chatId: number,
    userId: number,
  ): Promise<ChatMemebr[]> {
    const result = await $host.post("/chat/members/" + chatId, {
      users: [userId],
    });
    return result.data;
  }

  static async createChat(name: string): Promise<Chat[]> {
    const result = await $host.post("/chat/create/", { name });
    return result.data;
  }

  static async deleteChat(chatId: number): Promise<Chat[]> {
    const result = await $host.delete("/chat/" + chatId);
    return result.data;
  }

  static async getChatsForUser(userId: number): Promise<Chat[]> {
    const result = await $host.get("/chat/chats/" + userId);
    return result.data;
  }

  static async getChatMessages(chatId: number): Promise<ChatMessage[]> {
    const result = await $host.get("/chat/messages/" + chatId);
    return result.data;
  }

  static async postMessage(chatId: number, text: string) {
    const result = await $host.post("/chat/post/" + chatId, { text });
    return result.data;
  }

  static async getUnreadChats(userId: number) {
    const result = await $host.get("/chat/chats/" + userId + "/unread");
    return result.data;
  }

  static async savePushSubscription(subscription: PushSubscription) {
    const result = await $host.post("/chat/push-subscription", {
      subscription: subscription.toJSON(),
    });
    return result.data;
  }
}
